import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Copy, Landmark } from "lucide-react";
import { toast } from "sonner";
import { eur, getTransferInfo } from "../lib/api";

const Row = ({ label, value, id }) => {
  const copy = () => navigator.clipboard?.writeText(String(value).replace(/\s/g, label === "IBAN" ? "" : " ")).then(() => toast.success(`${label} copiado`)).catch(() => {});
  return (
    <div className="flex items-center justify-between gap-3 py-3 border-b border-[#F6EEDC]/10 last:border-0">
      <span className="text-sm text-[#C9D6C2]">{label}</span>
      <span className="flex items-center gap-2 text-right">
        <span data-testid={`transfer-${id}`} className="font-mono-d text-base sm:text-lg break-words">{value}</span>
        <button type="button" onClick={copy} aria-label={`Copiar ${label}`} data-testid={`transfer-copy-${id}`} className="w-9 h-9 shrink-0 rounded-full border border-[#F6EEDC]/20 grid place-items-center hover:border-[#F2B441]"><Copy className="w-4 h-4" /></button>
      </span>
    </div>
  );
};

export default function TransferPage() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!ref) { setError(true); return undefined; }
    getTransferInfo(ref).then(setInfo).catch(() => setError(true));
    return undefined;
  }, [ref]);

  return (
    <main data-testid="transfer-page" className="min-h-[100svh] max-w-xl mx-auto px-5 pt-28 pb-20">
      <Landmark className="w-10 h-10 text-[#8CD05A]" />
      <h1 className="font-serif-d font-black text-4xl sm:text-5xl mt-4">Pedido recibido</h1>
      {error && <p data-testid="transfer-error" className="mt-4 text-[#C9D6C2]">No encontramos este pedido. Revisa el correo que te hemos enviado.</p>}
      {info && (
        <>
          <p className="mt-4 text-[#C9D6C2]">{info.payment_status === "paid" ? "Hemos recibido tu transferencia. ¡Gracias!" : "Para completarlo, haz una transferencia con estos datos. También te los hemos enviado por correo."}</p>
          <div className="mt-6 rounded-[14px] border border-[#8CD05A]/25 bg-[#0E2A1C] px-5">
            <Row label="Titular" value={info.holder} id="holder" />
            <Row label="IBAN" value={info.iban} id="iban" />
            <Row label="Importe" value={eur(info.amount)} id="amount" />
            <Row label="Concepto" value={info.reference} id="reference" />
          </div>
          <p className="mt-4 text-sm text-[#C9D6C2]">Pon el concepto tal cual para identificar tu pago. Preparamos el envío en cuanto llega (normalmente 1-2 días laborables) y te avisamos por correo.</p>
        </>
      )}
      <Link to="/" data-testid="transfer-back-home" className="inline-flex mt-10 rounded-full border border-[#8CD05A]/40 px-7 h-12 items-center hover:border-[#F2B441] hover:text-[#F2B441] transition-colors">Volver a la tienda</Link>
    </main>
  );
}
